var Marionette = require('backbone.marionette');

var ReverseRelationCollection = require('../../collections/reverse-relations-collection');
var Relation = require('../../models/relation-model');
var PersonOrganizationModalView = require('../persons/person-organization-modal-view');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');
var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');


var OrganizationPersonsItem = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/organizations/organization-persons-item-view.html'),

    ui: {
        edit: '.org-person-edit',
        remove: '.org-person-remove'
    },

    events: {
        'click @ui.edit': 'onEdit',
        'click @ui.remove': 'onRemove'
    },

    templateContext: function () {
        var that = this;
        return {
            formatDate: that.getOption('formatDate'),
            canEdit: that.getOption('canEdit')
        }
    },

    initialize: function (options) {
    },

    onEdit: function () {
        this.triggerMethod('edit:org:person', this.model);
    },

    onRemove: function () {
        this.triggerMethod('remove:org:person', this.model);
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(4), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});


var OrganizationPersonsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: OrganizationPersonsItem,
    emptyView: EmptyView,

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    childViewEvents: {
        'edit:org:person': 'onEdit',
        'remove:org:person': 'onRemove'
    },

    initialize: function (options) {
        this.collection = options.collection;
        this.formatDate = options.formatDate;
        this.canEdit = options.canEdit;
    },

    childViewOptions: function () {
        return {
            formatDate: this.formatDate,
            canEdit: this.canEdit
        };
    },

    onEdit: function (model) {
        this.triggerMethod('edit:org:person', model);
    },

    onRemove: function (model) {
        this.triggerMethod('remove:org:person', model);
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    }
});

var OrganizationPersonsView = Marionette.View.extend({
    template: require('../../templates/organizations/organization-persons-view.html'),

    regions: {
        modal: '#organization-person',
        tableBody: {
            el: 'tbody',
            replaceElement: true
        },
        removeConfirmationModal: '#org-person-delete-confirmation-modal'
    },

    ui: {
        newRelBtn: '#new-person'
    },

    events: {
        'click @ui.newRelBtn': 'newRelation'
    },

    collectionEvents: {
        error: 'logError'
    },

    childViewEvents: {
        'edit:org:person': 'onEdit',
        'remove:org:person': 'onRemove',
        'saved:person:organization': 'onSavedOrganizationPerson',
        'action:confirmed': 'onRemoveConfirmed'
    },

    templateContext: function () {
        var that = this;
        return {
            canEdit: that.canEdit
        }
    },

    initialize: function (options) {
        this.organizationModel = options.organizationModel;
        this.organizationId = this.organizationModel.id;
        this.organizationName = this.organizationModel.name;
        this.canEdit = options.canEdit;
        this.utils = new CommonUtils();
    },

    onErrors: function (model, errors) {
        model.view.triggerMethod('server:error', errors.join('. \n'));
    },

    onRender: function () {
        var that = this;

        this.removeConfirmationModal = new YesNoConfirmationModal({
            tag: 'remove',
            message: "Are you sure you want to remove this relation?"
        });
        this.showChildView('removeConfirmationModal', this.removeConfirmationModal);

        that.collection = new ReverseRelationCollection([],
            {
                params: [
                    {key: 'systemRelationType', value: 'PERSON_ORGANIZATION'},
                    {key: 'parentId', value: that.organizationId}
                ]
            });

        that.reloadCollection();
    },

    renderEditor: function (model, originalModel, orgContacts, personContacts) {
        var excludedPersonsIds = this.collection.map(function (model) {
            return model.get("child").id;
        });

        this.personOrganizationModalView = new PersonOrganizationModalView({
            mode: 'organization',
            model: model,
            excludedPersonsIds: _.without(excludedPersonsIds,
                originalModel ? (originalModel.get("child") || {}).id : []),
            selectedPerson: originalModel ? originalModel.get("child") : null,
            orgContacts: orgContacts,
            personContacts: personContacts
        });
        this.showChildView('modal', this.personOrganizationModalView);
        this.personOrganizationModalView.show();
    },

    reloadCollection: function () {
        var that = this;
        that.showLoading();
        that.collection.fetch({
            success: function () {
                that.renderTable();
                that.hideLoading();
            },
            error: function () {
                that.hideLoading();
            }
        });
    },

    renderTable: function () {
        var that = this;
        that.showChildView('tableBody', new OrganizationPersonsTableBody({
            collection: that.collection,
            formatDate: function (dateAsLong) {
                return dateAsLong ? that.utils.longToDateTimeFormatted(dateAsLong, 'MMM DD YYYY') : "";
            },
            canEdit: that.canEdit
        }));
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    },

    newRelation: function () {
        this.renderEditor(new Relation({
            systemRelationType: 'PERSON_ORGANIZATION',
            child: {
                id: this.organizationId,
                '@class': "com.reviewandsign.reviewnsign.dal.entities.OrganizationDbo" // custom fix
            },
            contacts: [],
            description: ""
        }), null, (this.organizationModel.get('object') || {}).contacts, []);
    },

    onSavedOrganizationPerson: function () {
        this.reloadCollection();
    },

    onEdit: function (model) {
        var clonedModelAttributes = this.utils.deepClone(_.extend({}, model.attributes));
        var temp = _.clone(clonedModelAttributes.parentId);
        clonedModelAttributes.parentId = _.clone(clonedModelAttributes.child.id);
        clonedModelAttributes.child = {
            id: temp,
            '@class': "com.reviewandsign.reviewnsign.dal.entities.OrganizationDbo" // custom fix
        };
        var clonedModel = new Relation();
        clonedModel.set(clonedModelAttributes);
        this.renderEditor(clonedModel, model, (this.organizationModel.get('object') || {}).contacts, (model.get('child') || {}).object.contacts);
    },

    onRemove: function (model) {
        this.modelToRemove = model;
        this.removeConfirmationModal.show();
    },

    onRemoveConfirmed: function (resp) {
        var that = this;
        if (resp.tag === 'remove' && resp.result == true) {
            that.modelToRemove.destroy({
                success: function (model, resp) {
                    that.reloadCollection();
                    that.removeConfirmationModal.hide();
                }
            });
        }
        else {
            that.removeConfirmationModal.hide();
        }
    }
});


module.exports = OrganizationPersonsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/organizations/organization-persons-view.js
// module id = 276
// module chunks = 0